var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShowPageLoading)?_c('div',{staticClass:"mini-im-loading",class:{'pc-mini-im-loading': !_vm.isMobile}},[_c('mt-spinner',{attrs:{"type":"triple-bounce","color":"#26a2ff"}})],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }